import script from "./NewProgramInPulseStep6View.vue?vue&type=script&setup=true&lang=js"
export * from "./NewProgramInPulseStep6View.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__